export default {
  cn: [
    {
      version: '1.8',
      time: '2018.09.10',
      changes: [
        '增加部分参数允许在插件安装时进行全局设置',
        '修改参数设置方式，从参数集对象的方式更换为单属性设置'
      ]
    }, {
      version: '1.7',
      time: '2018.05.21',
      changes: [
        '增加 <code>buttonText</code> 参数，允许自定义按钮显示文本',
        '增加 <code>buttonIcon</code> 参数，允许自定义按钮图标是否显示',
        '增加 <code>previewImg</code> 参数，允许自定义预览区初始化显示的图片'
      ]
    }, {
      version: '1.4-1.6',
      time: '2018.05.09',
      changes: [
        '修复部分文件错误的情况',
        '修复控制台读取图片 404 的问题',
        '修复部分情况下 i18n 读取异常',
        '增加 <code>preview</code> 参数，用于设置是否显示预览框（单选模式）'
      ]
    }, {
      version: '1.3',
      time: '2018.04.29',
      changes: [
        '修复批量上传模式图标不显示的问题'
      ]
    }, {
      version: '1.2',
      time: '2018.04.28',
      changes: [
        '修复批量上传模式上传限制信息没显示的问题'
      ]
    }, {
      version: '1.1',
      time: '2018.04.28',
      changes: [
        '修复同个界面上使用多 <code>v-uploader</code> 时，文件始终只会上传到最后一个插件上的问题'
      ]
    }, {
      version: '1.0',
      time: '2018.04.27',
      changes: [
        '开发并发布基于 <strong>Vue2.x</strong> 的 <code>v-uploader</code> 文件上传插件'
      ]
    }
  ],

  en: [
    {
      version: '1.8',
      time: '2018.09.10',
      changes: [
        'Add some options can config when plugin install',
        'Modify the options setting method, change from option set to attribute'
      ]
    }, {
      version: '1.7',
      time: '2018.05.21',
      changes: [
        'add <code>buttonText</code> option，custom button text',
        'add <code>buttonIcon</code> option，control button icon show or not, default <code>true</code>',
        'add <code>previewImg</code> option，init preview area image'
      ]
    }, {
      version: '1.4-1.6',
      time: '2018.05.09',
      changes: [
        'Fixed some wrong text in i18n.',
        'Fixed loading image fail(404) in console.',
        'Fixed i18n load issues in sometime.',
        'add <code>preview</code> option, use to set thumbnail show or not(work on single upload mode).'
      ]
    }, {
      version: '1.3',
      time: '2018.04.29',
      changes: [
        'Fixed control button icon is not display in multiple upload mode.'
      ]
    }, {
      version: '1.2',
      time: '2018.04.28',
      changes: [
        'Fixed upload file limit info is not display in multiple upload mode.'
      ]
    }, {
      version: '1.1',
      time: '2018.04.28',
      changes: [
        'Fixed use one more <code>v-uploader</code> plugin in same page/component, anyone <code>v-uploader</code> uploaded file info will update to last one <code>v-uploader</code> .'
      ]
    }, {
      version: '1.0',
      time: '2018.04.27',
      changes: [
        'develop and publish <code>v-uploader</code> plugin for <strong>Vue2.x</strong>'
      ]
    }
  ]
}
